import { useEffect, useState } from "react";
import OrderList from "../List/OrderList";
import { Column } from "../../../Components/Tables/Table";
import { useNavigate } from "react-router-dom";
import { TabConfig } from "../../../model/common/tabs";
import { useSearchStore } from "../../../store/search/searchStore";
import Loader from "../../../Components/GlobalLoader/Loader";
import useEventSystem from "../../../events/useEventSystem";
import { ThreeDotsVertical } from "react-bootstrap-icons";
import { formatDate, formatNumber, prepareSearchColumns } from "../../../Utility/Utility";
import { OrderOverview } from "./model/order.model";
import useClientStore from "../../../store/client/useClientStore";
import CommonConfirmationModal from "../../../Components/Modals/CommonConfirmationModal";
import toast, { Toaster } from "react-hot-toast";
import { deallocateOrderById, deleteOrderById } from "./service/orderOverview.service";
import { error } from "console";

interface OutboundOrderProps {
  pageName: string;
  headerName: string;
}

const defaultProps: OutboundOrderProps = {
  pageName: "Order Entry",
  headerName: "Orders",
};
export default function OutboundOverview(props: OutboundOrderProps) {
  const { pageName, headerName} = props;
  const [clientId, setClientId] = useState<any>(null);
  const navigation = useNavigate();
  const { resetSearch } = useSearchStore();
  const [loading, setLoading] = useState(true);
  const addUrl = "/outbound/orders/add";
  const listUrl = "/outbound/orders";
  const buttonStatus = true;
  const { emit } = useEventSystem();
  const { getSelectedClient } = useClientStore();
  useEffect(() => {

    const subscriptionClient = getSelectedClient().subscribe((client) => {
      setClientId(client?.id);
    });

    return () => {
      subscriptionClient.unsubscribe();
    };
  }, [getSelectedClient]);
  const [confirmModalData, setConfirmModalData] = useState({
    id: 0,
    showconfModal: false,
    message: ''
  });

  const [deallocateModalData, setDeallocateModalData] = useState({
    id: 0,
    showconfModal: false,
    message: ''
  });

  const handelCancelAction = (data: OrderOverview) => {
    setConfirmModalData({
      id: data.id,
      showconfModal: true,
      message: `You are about to delete this Order which has ${data.no_of_shipments} Shipments. Are you sure?`
    });
  };

  const handelDeallocateAction = (data: OrderOverview) => {
    setDeallocateModalData({
      id: data.id,
      showconfModal: true,
      message: `You are about to deallocate this order number ${data.order_number}. Are you sure?`
    });
  };

  const handleconfClose = () => {
    setConfirmModalData({
      id: 0,
      showconfModal: false,
      message: ''
    });
  };

  const handleDeallocateClose = () => {
    setDeallocateModalData({
      id: 0,
      showconfModal: false,
      message: ''
    });
  };

  const onCancelOrderSubmit = async(isAccept: boolean) => {
    if(confirmModalData.id !== 0 && isAccept){
        const response = await deleteOrderById(confirmModalData.id.toString());
        if (response.status == 200) {
         window.location.reload();
        } else {
          toast.error("Failed to delete the Order!");
        }
    }
    handleconfClose();
  };

 const onDeallocateSubmit = async(isAccept: boolean) => {
    if(deallocateModalData.id !== 0 && isAccept){
      handleDeallocateClose();
      try {
        const response = await deallocateOrderById(deallocateModalData.id);
        if (response.status == 200) {
          toast.success("Order deallocated successfully!");
          setTimeout(() => window.location.reload(), 1000);
        } else {
          if (response.error && response.error.detail) {
            toast.error(response.error.detail);
          } else {
            toast.error("Failed to deallocate the Order!");
          }
        }
      } catch (error: any) {
        const detail =
          error?.response?.data?.error?.detail ||
          error?.response?.data?.detail ||
          error?.message ||
          "Failed to deallocate the Order!";
        console.log('error', detail);
        toast.error(detail);
      }
    }
    handleDeallocateClose();
  };

  const db_columns = [
    { data: "sales_order.id" },
    { data: "sales_order.order_number" },
    { data: "sales_order.ship_to_name" },
    { data: "sales_order.ship_by_date" },
    { data: "sales_order.no_of_lines" },
    { data: "sales_order.no_of_shipments" },
    { data: "sales_order.no_of_warehouses" },
    { data: "sales_order.total_qty_ordered" },
    { data: "sales_order.total_qty_shipped" },
    { data: "sales_order.status" },
  ];

  const exclude_columns = ["sales_order.no_of_lines", "sales_order.no_of_shipments", "sales_order.no_of_warehouses", "sales_order.total_qty_ordered", "sales_order.total_qty_shipped", "sales_order.status"];
  const search_columns = prepareSearchColumns(db_columns, exclude_columns);
  const columns: Column[] = [
    {
      name: "Order #",
      column_name: "sales_order.order_number",
      enableSorting: true,
      selector: (row: OrderOverview) => (
        <span className="cursor-pointer text-primary" onClick={() => handleRowClick(row)}>{row.order_number}</span>
      ),
    },
    {
      name: "Ship-to Name ",
      column_name: "sales_order.ship_to_name",
      selector: (row: OrderOverview) => row.ship_to_name,
      enableSorting: true,
    },
    {
      name: "Ship-by Date",
      column_name: "sales_order.ship_by_date",
      selector: (row:OrderOverview) => (
        <>
            {row.ship_by_date ? formatDate(row.ship_by_date): '-'}
        </> 
      ),
      enableSorting: true,
    },
    {
      name: "No. of Lines",
      column_name: "sales_order.no_of_lines",
      selector: (row: OrderOverview) => row.no_of_lines,
    },
    {
      name: "No. of Shipments",
      column_name: "sales_order.no_of_shipments",
      selector: (row: OrderOverview) => row.no_of_shipments,
    },
    {
      name: "No. of Warehouses",
      column_name: "sales_order.no_of_warehouses",
      selector: (row: OrderOverview) => row.no_of_warehouses,
    },
    {
      name: "Ordered Qty",
      column_name: "sales_order.total_qty_ordered",
      selector: (row: OrderOverview) => formatNumber(row.total_qty_ordered),
    },
    {
      name: "Shipment Qty",
      column_name: "sales_order.total_qty_shipped",
      selector: (row: OrderOverview) => formatNumber(row.total_qty_shipped),
    },
    {
      name: (
        <>
        </>
      ),
      selector: (row: OrderOverview) => (
        <>
          <span
            className="cursor-pointer dropdown-toggle action-menu border-none"
            data-bs-toggle="dropdown"
            aria-expanded="false"
          >
            <ThreeDotsVertical />
          </span>
          <ul className="dropdown-menu action-items px-0 py-1">
            <li
              key={1}
              className="cursor-pointer ms-3 mb-1 fs-14 fw-bold"
              onClick={() => handleRowClick(row)}
            >
              View
            </li>
            <li
              key={2}
              className="cursor-pointer ms-3 mb-1 fs-14 fw-bold"
              onClick={() => handleRowEdit(row)}
            >
              Edit
            </li>
            <li
              key={3}
              className="cursor-pointer ms-3 mb-1 fs-14 fw-bold"
              onClick={() => handelCancelAction(row)}
            >
              Cancel Order
            </li>
            <li
              key={4}
              className="cursor-pointer ms-3 mb-1 fs-14 fw-bold"
              onClick={() => handelDeallocateAction(row)}
            >
              Deallocate
            </li>
          </ul>
        </>
      ),
    },
  ];

  const pageTabs: TabConfig[] = [
    { order: 0, name: "New", tabLable: "New", visibility: true, status: true, multiSelect: null },
    { order: 1, name: "In Progress", tabLable: "In Progress", visibility: true, status: false, multiSelect: null },
    { order: 2, name: "Completed", tabLable: "Completed", visibility: true, status: true, multiSelect: null },
  ];

  const handleRowClick = (data: OrderOverview) => {
    return navigation(`/outbound/orders/details/${data.id}`);
  };
  const handleRowEdit=(data:OrderOverview)=>{
    return navigation(`/outbound/orders/edit/${data.id}`);
  }

  useEffect(() => {
    resetSearch();
    setLoading(false);
    emit("show_client_warning", false);
  }, [resetSearch, emit]);


  return !loading ? (
    <>
     <Toaster />
    <OrderList
      db_columns={db_columns}
      search_columns={search_columns}
      columns={columns}
      pageName={pageName}
      headerName={headerName}
      addUrl={addUrl}
      listUrl={listUrl}
      pageTabs={pageTabs}
      buttonStatus={buttonStatus}
      checkboxStatus={false}
      tableMultiSelect={null}
      clientId={clientId}
    />
    <CommonConfirmationModal
      customClassName="header-border"
      show={confirmModalData.showconfModal}
      content={<> {confirmModalData.message} </>}
      onModalSubmit={onCancelOrderSubmit}
    />
    <CommonConfirmationModal
      customClassName="header-border"
      show={deallocateModalData.showconfModal}
      content={<> {deallocateModalData.message} </>}
      onModalSubmit={onDeallocateSubmit}
      confirmBtnText="Deallocate"
      cancelBtnText="Cancel"
    />
    </>
  ) : (
    <Loader />
  );

}
OutboundOverview.defaultProps = defaultProps;
